module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clock"
  }, [_c('span', [_vm._v(_vm._s(_vm.localTime))]), _vm._v(" "), _c('span', [_vm._v("Next Week Begins in "), _c('span', {
    style: ({
      'color': _vm.color
    })
  }, [_vm._v(_vm._s(_vm.weekStarts))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f3570f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Clock.vue
// module id = 2065
// module chunks = 2